export enum Contracts {
  Lumia = 'Lumia',
  ERC20 = 'ERC20',
  Exchange = 'Exchange',
  VeOrn = 'VeOrn',
  VeOrnVoting = 'VeOrnVoting',
  OrionToLumiaConverter = 'OrionToLumiaConverter',
}
